
import { dataStructureActionTypes } from '@constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = {
    taxHouseholdStructure: null
};

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case dataStructureActionTypes.SET_DATA_STRUCTURE:
            return {
                ...state,
                ...action.update
            };
            
        case dataStructureActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
            
        default:
            return state;
    }
};